import React from 'react';
import styles from './Layout.module.scss';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-grid-system';
import { UserBadge, Button } from 'condolivre-ds';
import iconLogout from 'condolivre-ds/build/static/icon/icon_sm_logout.svg';
import Footer from '../Footer/Footer';
import { getUser } from '@/helpers/cookies';
import MenuSideBar from '@/components/MenuSideBar/MenuSideBar';
import { Header } from '@/components/Header/Header';

// TODO Update to next/link
// TODO: Uncomment hidden menus
export default function Layout({
    children,
    isAuthenticated,
    showSidebar,
    className,
    showHeader,
    header,
    footer,
    isLogin
}) {
    if (isAuthenticated) {
        const user = getUser();
        return (
            <>
                <div className={styles.contentWrapper}>
                    {showSidebar && <MenuSideBar />}
                    <div className={styles.content}>
                        <Container>
                            <Row className={'header-menu'}>
                                <Col md={10} className={'header-menu__badge'}>
                                    <UserBadge
                                        color={'blue_50'}
                                        name={user && user.name}
                                        user
                                        id={'user-badge'}
                                    />
                                </Col>
                                <Col md={2} className={styles.justifyEnd}>
                                    <a href={'/logout'}>
                                        <Button
                                            className="header-menu__logout"
                                            variant={'primary'}
                                            size={'small'}
                                            icon={iconLogout.src}
                                            iconPos={'left'}>
                                            Sair
                                        </Button>
                                    </a>
                                </Col>
                            </Row>
                        </Container>
                        {children}
                    </div>
                </div>
                <Footer />
            </>
        );
    } else {
        const loginClassName = isLogin ? styles.login : '';

        return (
            <>
                {showHeader && header}
                <div className={[loginClassName, className].join(' ')}>{children}</div>
                {footer}
            </>
        );
    }
}

Layout.propTypes = {
    isAuthenticated: PropTypes.bool,
    showSidebar: PropTypes.bool,
    children: PropTypes.node,
    header: PropTypes.any,
    showHeader: PropTypes.bool,
    className: PropTypes.any,
    isLogin: PropTypes.bool
};

Layout.defaultProps = {
    header: <Header />,
    footer: <Footer />,
    showHeader: false,
    showSidebar: true,
    isAuthenticated: false,
    isLogin: true
};
